import type { ChangelogEntry } from "types/changelog.types"

export const changelogEntriesEs: ChangelogEntry[] = [
  {
    release: "2026-11-02",
    changes: [
      {
        type: "new",
        title: "Detalles de la torre en la pestaña Configuración",
        description:
          "La pestaña Configuración de la página de la torre muestra los detalles de la torre: información general (nombre, ID, tipo, funcionalidad y altura), ubicación (coordenadas, altitud, orientación y ángulo de deflexión) y aisladores (tipo y longitud).",
      },
      {
        type: "improved",
        title: "Nuevo selector de fechas",
        description:
          'El selector de fechas ahora es más fácil de leer y de usar. Los períodos se agrupan en horas, días y más largos, y el período seleccionado aparece resaltado, con sus fechas exactas arriba de la lista. Los períodos que incluyen pronóstico mantienen su nombre corto y muestran una etiqueta. Un período personalizado ahora se elige en un único calendario y solo se aplica al presionar Aplicar, así los gráficos no se recargan mientras se eligen las fechas. Una vez aplicado, el botón muestra esas fechas en lugar de "Periodo personalizado". En teléfonos el selector se abre en pantalla completa.',
      },
      {
        type: "improved",
        title: "Columna de entidad en la tabla de eventos",
        description:
          "Las columnas de tipo de entidad y entidad de la tabla de eventos se unieron en una sola columna que muestra el ícono, el nombre y el ID de la entidad, igual que las tablas de dispositivos y líneas eléctricas. La exportación a CSV ahora lista el tipo, el nombre y el ID de la entidad en columnas separadas.",
      },
      {
        type: "improved",
        title: "Resistencia del conductor más precisa para la ampacidad",
        description:
          "Los valores de ampacidad calculan la resistencia del conductor a partir de su cableado cuando sus datos por capa están completos, y las líneas de corriente continua se evalúan con su resistencia en continua. A corriente alta, los valores de los conductores ACSR de tres capas de aluminio pueden ser alrededor de un 1 % más bajos; los conductores sin datos completos por capa no cambian.",
      },
    ],
  },
  {
    release: "2026-10-26",
    changes: [
      {
        type: "new",
        title: "Gestión de alertas desde la pestaña Alertas",
        description:
          "Las alertas se pueden crear y editar desde un panel lateral en la pestaña Alertas de dispositivos, líneas eléctricas y torres, y habilitar, deshabilitar y eliminar desde el menú de cada alerta. También se listan las alertas deshabilitadas, con un filtro para encontrarlas. La configuración de alertas ya no está en la pestaña Configuración. Las alertas muestran su nombre, tipo, entidad y último disparo en un encabezado más compacto, y las listas permiten elegir cuántas alertas mostrar por página, volviendo a la primera al cambiar un filtro.",
      },
      {
        type: "improved",
        title: "La tabla de líneas eléctricas se lee como la de dispositivos",
        description:
          "Las columnas de nombre e ID de la tabla de líneas eléctricas se unieron en una sola columna Línea eléctrica, con el ícono de línea eléctrica, el nombre y el ID debajo, igual que la tabla de dispositivos muestra los dispositivos.",
      },
      {
        type: "improved",
        title: "Un mismo estilo para diálogos y menús",
        description:
          "Los diálogos, menús, ventanas emergentes y tooltips de los gráficos comparten un mismo estilo en toda la plataforma. Todos los diálogos tienen el mismo encabezado y botones, eliminar un usuario pide confirmación igual que eliminar un grupo, y la opción enfocada y la seleccionada en un desplegable se ven mejor.",
      },
      {
        type: "fixed",
        title: "Dispositivos instalados",
        description:
          'Un dispositivo cuenta como instalado solo cuando tiene su vano o su torre. Los que no los tienen aparecen en No instalados, con "-" en la columna Instalado en, y no se cuentan en los gráficos de la página de la organización.',
      },
      {
        type: "fixed",
        title: "Guardado de los detalles de instalación",
        description:
          "Se corrigió que la tarjeta de detalles de instalación quedara cargando indefinidamente después de guardar. Cambiar la torre B ahora borra el vano para que se vuelva a elegir, la fecha de instalación se pide solo después de elegir un tipo de instalación, y una instalación en línea eléctrica necesita ambas torres y el vano para guardarse.",
      },
    ],
  },
  {
    release: "2026-10-19",
    changes: [
      {
        type: "new",
        title: "Alertas abiertas en la página de inicio",
        description:
          "La página de inicio muestra las alertas abiertas de la organización debajo de su nombre, con cuántas líneas eléctricas, torres y dispositivos afectan y un enlace a la vista general de alertas. Cuando no hay ninguna, lo indica.",
      },
      {
        type: "new",
        title: "Pestaña de configuración de alertas",
        description:
          "Cada alerta muestra su configuración en una nueva pestaña: los umbrales con el estado que fija cada uno, los campos que observa y su configuración de resolución, notificación y nota.",
      },
      {
        type: "improved",
        title: "Ventanas emergentes del mapa como tarjetas",
        description:
          "Las ventanas emergentes del mapa se rediseñaron como tarjetas, con el nombre de la entidad enlazado a su página y la unidad junto a cada valor. La de un dispositivo muestra el vano o la torre en que está instalado, con un enlace, y la versión del dispositivo. Las de vanos y torres listan los dispositivos instalados en ellos, con un enlace a cada uno.",
      },
      {
        type: "improved",
        title: "Tablas más estables",
        description:
          "Se rediseñaron las tablas de toda la plataforma para que las filas mantengan una misma altura, las columnas conserven su ancho y la tabla mantenga su tamaño al cambiar de página, con los textos largos acortados y mostrados completos al pasar el cursor.",
      },
      {
        type: "fixed",
        title: "CSV completo de la auditoría",
        description:
          "Se corrigió la descarga en CSV de la auditoría para que incluya todos los registros del período seleccionado, no solo las páginas ya vistas. El nombre del archivo ahora incluye la organización y el rango de fechas seleccionado.",
      },
      {
        type: "fixed",
        title: "Errores de carga de la auditoría",
        description:
          "Se corrigió que la tabla de auditoría quedara cargando indefinidamente cuando fallaba la carga de los registros; ahora indica que no se pudieron cargar los datos.",
      },
    ],
  },
  {
    release: "2026-10-05",
    changes: [
      {
        type: "new",
        title: "Página del vano",
        description:
          "Los vanos ahora tienen su propia página. Se abre con los gráficos de largo plazo de ampacidad y de temperatura del conductor, con la ampacidad nominal del vano y sus temperaturas máximas de operación y de emergencia dibujadas sobre ellos, junto a la última ampacidad y temperatura del conductor AAR y DLR, y con qué frecuencia el vano operó por debajo de la nominal. Una pestaña de configuración reúne los detalles del vano y su conductor. Se puede recorrer la línea vano por vano y llegar a la página desde la ventana emergente del mapa, desde un dispositivo o desde la tabla de dispositivos.",
      },
      {
        type: "new",
        title: "Conductores en la configuración de la línea eléctrica",
        description:
          "La pestaña de Configuración de una línea eléctrica ahora lista sus conductores, con el tipo, el nombre, la sección nominal y el diámetro de cada uno. Al hacer clic en un conductor se abre su ficha técnica completa: geometría, capas, propiedades térmicas y mecánicas, y resistencia eléctrica por tipo de corriente y temperatura. Todos los valores se muestran en las unidades de la ficha técnica.",
      },
      {
        type: "improved",
        title: "La ampacidad del vano ahora está en la página del vano",
        description:
          "Los gráficos de ampacidad del vano ya no están en la pestaña Vano de un dispositivo. La página del vano grafica los mismos datos junto con DLR y los pronósticos, y la pestaña enlaza a ella.",
      },
      {
        type: "improved",
        title: "Línea, ubicación y dispositivos en los encabezados",
        description:
          "Las páginas de vanos, torres y dispositivos muestran la línea eléctrica, la ubicación y los dispositivos instalados en un solo bloque debajo del encabezado, con el estado de reporte de cada dispositivo.",
      },
      {
        type: "fixed",
        title: "Ilustraciones de postes en las vistas de inclinación",
        description:
          "Los dispositivos con monitoreo de salud de torres instalados en un poste ahora muestran un poste en lugar de una torre de celosía, y las tarjetas de inclinación muestran el dispositivo del lado del poste en el que está montado. El diagrama de inclinación detrás del ícono de información se redibujó para coincidir.",
      },
      {
        type: "fixed",
        title: "Carga de la tabla de auditoría",
        description:
          "Se corrigió que la tabla de auditoría quedara en estado de carga al volver a aceptar el mismo rango de fechas personalizado.",
      },
    ],
  },
  {
    release: "2026-09-21",
    changes: [
      {
        type: "new",
        title: "Panel de vano limitante en líneas eléctricas",
        description:
          "La pestaña Vista general de una línea eléctrica ahora muestra con qué frecuencia cada vano fue el que limitó la ampacidad de la línea durante el período seleccionado, tanto para el método AAR como para el DLR, en lugar del mapa de ubicación simple. El mapa resalta con un anillo el vano más frecuente de cada método y señala el vano que limita la línea en este momento, con la hora de su último reporte. Debajo, un gráfico por vano con una franja por método indica la participación y la cantidad de eventos de cada vano al pasar el cursor; al hacer clic en un vano el mapa se desplaza hasta él, y al pasar el cursor o seleccionar un vano en cualquiera de las dos vistas se resalta en la otra. El gráfico muestra una ventana de vanos a un ancho legible, con una franja debajo que muestra la línea completa: arrastre la ventana para moverla, arrastre cualquiera de sus bordes para redimensionarla o use Ver todos para ver todos los vanos.",
      },
      {
        type: "new",
        title: "Detalles de la línea eléctrica",
        description:
          "La pestaña de Configuración de una línea eléctrica ahora se abre con sus detalles: ID, fecha de instalación y última actualización, su tensión, frecuencia y ampacidad nominales, y su longitud, vanos y torres.",
      },
      {
        type: "fixed",
        title: "Cruceta en teléfonos y tabletas",
        description:
          "La cruceta de los gráficos de líneas y de dispersión ahora funciona en teléfonos y tabletas además de con el mouse.",
      },
    ],
  },
  {
    release: "2026-09-14",
    changes: [
      {
        type: "improved",
        title: "Rendimiento del mapa en organizaciones grandes",
        description:
          "Se mejoró la carga del mapa en organizaciones con muchas torres o vanos. Las capas de torres y vanos ahora se construyen solo cuando se activan, por lo que los mapas se abren y se desplazan más rápido. Al activar una capa puede haber una breve espera la primera vez mientras se dibujan sus marcadores.",
      },
      {
        type: "fixed",
        title: "Torres y vanos sin nombre",
        description:
          "Las torres y los vanos sin nombre ahora aparecen como Sin nombre en lugar de null. Esto abarca los detalles de instalación de un dispositivo y sus selectores de torre y vano, el mapa del panel de la torre y el nombre del archivo de descarga de alertas, como ya sucedía con las líneas eléctricas.",
      },
      {
        type: "fixed",
        title: "Selección de período en teléfonos y tabletas",
        description:
          "La selección de un período en los gráficos de líneas y de dispersión ahora funciona en teléfonos y tabletas: coloque dos dedos sobre el gráfico para marcar los extremos del período.",
      },
    ],
  },
  {
    release: "2026-09-07",
    changes: [
      {
        type: "improved",
        title: "Pestañas de Vista general",
        description:
          "Se renombró la pestaña de Información a Vista general en las páginas de dispositivo, línea eléctrica, torre y grupo de dispositivos. Solo cambió la etiqueta; la pestaña muestra el mismo contenido que antes.",
      },
      {
        type: "fixed",
        title: "Valores faltantes en la tabla de líneas eléctricas",
        description:
          "Se corrigió que la tabla de líneas eléctricas mostrara NaN en Ampacidad nominal y Tensión nominal cuando la línea eléctrica no tiene un valor configurado. Esas columnas y la descarga de CSV ahora muestran un guion, como ya lo hacía Longitud.",
      },
      {
        type: "fixed",
        title: "Búsqueda en alertas con líneas eléctricas sin nombre",
        description:
          "Se corrigió la falla de la búsqueda en la tabla de Alertas cuando una línea eléctrica no tiene nombre. Las líneas eléctricas sin nombre ahora aparecen como Sin nombre allí y en el detalle de la alerta, como ya sucedía en las tarjetas de línea eléctrica y de torre.",
      },
    ],
  },
  {
    release: "2026-08-31",
    changes: [
      {
        type: "fixed",
        title: "Corrección del viento en la ampacidad DLR",
        description:
          "Se corrigió la forma en que se aplica el viento medido por el dispositivo al calcular la ampacidad DLR: ahora se considera correctamente perpendicular al conductor. Los valores de DLR de los vanos afectados estaban subestimados y ahora alcanzan su valor correcto. No se requiere ninguna acción.",
      },
    ],
  },
  {
    release: "2026-08-10",
    changes: [
      {
        type: "new",
        title: "Pestañas de Alertas y Configuración para torres",
        description:
          "Se añadieron las pestañas de Alertas y Configuración a la página de torre, donde se pueden configurar alertas sobre los campos de telemetría de la torre y revisar los eventos que las activaron. Disponible para torres con salud monitoreada.",
      },
      {
        type: "improved",
        title: "Pestaña de Alertas unificada",
        description:
          "Se unificaron las pestañas de Alertas y Registro de eventos de las páginas de dispositivo, línea eléctrica y grupo de dispositivos en una sola pestaña de Alertas con dos subpestañas: Alertas configuradas y Actividad. La tabla de Actividad mantiene su propio rango de fechas, y tanto la subpestaña seleccionada como el rango se pueden compartir mediante la URL.",
      },
      {
        type: "new",
        title: "Menú interactivo de descarga de CSV",
        description:
          "Se rediseñó la descarga de CSV como un menú interactivo. Al hacer clic en el botón de descarga junto al selector de fechas se abre un panel donde se puede definir el rango de fechas, elegir qué fuentes incluir y seleccionar los campos individuales de cada fuente. Cuando la selección abarca más de un archivo, se pueden descargar por separado o en un único archivo .zip.",
      },
    ],
  },
  {
    release: "2026-07-27",
    changes: [
      {
        type: "new",
        title: "Pestaña de segmentos para torres",
        description:
          "Se añadió una nueva pestaña de Segmentos a la página de torre, que muestra la magnitud de flexión, desglosada en sus componentes longitudinal y lateral, y la torsión, de cada segmento monitoreado de la torre. Disponible para torres con salud monitoreada.",
      },
    ],
  },
  {
    release: "2026-07-21",
    changes: [
      {
        type: "new",
        title: "Rediseño de la página de torre",
        description:
          "Se introdujo un nuevo diseño de la página de torre para torres con salud monitoreada, que se muestra cuando hay 2 o más dispositivos instalados. Muestra información de inclinación de la torre con vistas ilustrativas y un resumen de los datos de los dispositivos instalados.",
      },
      {
        type: "new",
        title: "Pestaña de ambiente para dispositivos en vanos",
        description:
          "Se añadió una pestaña de Ambiente que muestra datos meteorológicos de un servicio externo para dispositivos en vanos. Solo aparece cuando el dispositivo tiene una geolocalización configurada.",
      },
      {
        type: "new",
        title: "Títulos de página dinámicos",
        description:
          "Cada página ahora establece su propio título en la pestaña del navegador, mostrando el nombre de la entidad (dispositivo, torre, línea eléctrica, grupo, organización) cuando corresponde.",
      },
      {
        type: "new",
        title: "Gráfico de histórico de ampacidad a corto plazo",
        description:
          "Se añadió un nuevo gráfico de líneas en la página de información de la línea eléctrica que muestra el histórico de ampacidad a corto plazo. Grafica los pronósticos de 5, 10 y 15 minutos sobre el rango de fechas seleccionado, complementando la tabla de ampacidad a corto plazo activa.",
      },
      {
        type: "new",
        title: "Límite de velocidad del viento configurable por línea eléctrica",
        description:
          "El límite de velocidad del viento utilizado para el Ambient Adjusted Rating (AAR) y los pronósticos AAR/DLR ahora se puede ajustar por línea eléctrica bajo solicitud. Las líneas eléctricas sin un valor personalizado mantienen el valor conservador previo por defecto de 0,6 m/s, por lo que las clasificaciones existentes no cambian.",
      },
      {
        type: "improved",
        title: "Datos sin procesar en gráficos de alertas",
        description:
          "Los gráficos de alertas ahora muestran datos sin procesar para periodos menores a 24 horas, y el gráfico se muestra primero en el detalle de la alerta para un acceso más rápido.",
      },
      {
        type: "improved",
        title: "Interacción y rendimiento de los gráficos",
        description:
          "Se redujo la cantidad de puntos de datos mostrados en periodos agregados para mejorar la interacción al pasar el cursor y el rendimiento general tanto en escritorio como en móvil.",
      },
      {
        type: "improved",
        title: "Actualización de seguridad en el backend",
        description: "Se implementaron correcciones de seguridad en el backend.",
      },
      {
        type: "fixed",
        title: "Pestañas vacías en gráficos con múltiples pestañas",
        description:
          'Se corrigió la desaparición de los gráficos con múltiples pestañas al cambiar a una pestaña sin datos en el rango seleccionado, más notable tras hacer zoom. El gráfico ahora permanece en su lugar con sus pestañas disponibles y muestra un mensaje de "no hay datos en la ventana de tiempo seleccionada".',
      },
      {
        type: "fixed",
        title: "Posición del tooltip en gráficos al desplazarse",
        description:
          "Se corrigió el tooltip en gráficos de líneas y de dispersión que aparecía en la esquina superior izquierda cuando un gráfico se desplazaba bajo un cursor estático. Ahora el tooltip aparece en la posición correcta junto al cursor.",
      },
    ],
  },
  {
    release: "2026-07-06",
    changes: [
      {
        type: "improved",
        title: "Línea de referencia de ampacidad estacional",
        description:
          "La línea de referencia de ampacidad nominal en el gráfico de ampacidad de la línea eléctrica ahora admite valores estacionales. Cuando una línea eléctrica define valores de ampacidad estacionales, la línea de referencia se vuelve escalonada, cambiando su nivel en las fechas configuradas y etiquetando cada segmento con su valor. La estadística de porcentaje por debajo de la ampacidad nominal también tiene esto en cuenta, comparando cada punto de datos con el valor estacional vigente en su fecha. Las líneas eléctricas sin valores estacionales continúan mostrando la línea de ampacidad nominal única.",
      },
      {
        type: "new",
        title: "Métricas de ampacidad a nivel de vano",
        description:
          "Las métricas de ampacidad ahora se registran a nivel de vano individual para los cálculos actuales, de pronóstico y DLR.",
      },
    ],
  },
  {
    release: "2026-06-29",
    changes: [
      {
        type: "improved",
        title: "Manejo de errores en gráficos",
        description:
          "Se mejoró el manejo de errores en los gráficos. Si solo una parte de los datos pudo cargarse, el gráfico muestra una advertencia junto con los datos disponibles y una opción de reintentar. Si todos los datos fallaron al cargar, el gráfico muestra un mensaje de error y una opción de reintentar.",
      },
      {
        type: "improved",
        title: "Mapa movido a la pestaña de dispositivo",
        description:
          "Se movió el mapa a la pestaña de dispositivo en la página de dispositivo para una mejor organización de la información relacionada con el dispositivo.",
      },
      {
        type: "improved",
        title: "Vista de tabla de ampacidad a corto plazo",
        description:
          "Se reemplazaron las tres estadísticas individuales de ampacidad a corto plazo (Próximos 5, 10 y 15 min) por una tabla única que muestra el intervalo de tiempo, el valor de ampacidad y la marca de tiempo de medición para cada intervalo de pronóstico en un formato más compacto y legible.",
      },
      {
        type: "new",
        title: "Porcentaje por debajo de la ampacidad nominal",
        description:
          "Se añadió una nueva estadística en la página de información de la línea eléctrica que muestra el porcentaje de puntos de datos por debajo del umbral de ampacidad nominal, desglosado por DLR y AAR. El porcentaje se calcula sobre la serie de ampacidad para el rango de fechas seleccionado, proporcionando un resumen rápido de con qué frecuencia cada método de clasificación opera por debajo de la capacidad nominal.",
      },
      {
        type: "new",
        title: "Telemetrías de inclinación para dispositivos en torres",
        description:
          "Para determinados dispositivos en torres, la sección de posición del dispositivo ahora muestra nuevas telemetrías, referenciadas al frente de la torre en lugar de a la orientación del dispositivo: inclinación frontal e inclinación lateral, magnitud y dirección, junto con sus estadísticas de amplitud y desviación.",
      },
    ],
  },
  {
    release: "2026-06-22",
    changes: [
      {
        type: "fixed",
        title: "Puntos fantasma en gráficos de dispersión tras hacer zoom",
        description:
          "Se corrigió la persistencia de puntos de datos en gráficos de dispersión al cambiar el rango de fechas.",
      },
      {
        type: "fixed",
        title: "Activación del hover en puntos distantes en gráficos de dispersión",
        description:
          "Se corrigió la activación del resaltado al pasar el cursor sobre áreas lejanas o vacías en gráficos de dispersión. Ahora el hover solo se activa cuando el cursor está dentro de un radio corto del punto de datos más cercano.",
      },
    ],
  },
  {
    release: "2026-06-15",
    changes: [
      {
        type: "new",
        title: "Alertas para torres de líneas eléctricas",
        description:
          "Se añadió la gestión de configuración de alertas para torres de líneas eléctricas. Los usuarios ahora pueden crear, modificar y eliminar alertas de umbral para campos de telemetría de torres a través del endpoint de configuración de alertas.",
      },
    ],
  },
  {
    release: "2026-06-10",
    changes: [
      {
        type: "improved",
        title: "Estados de reporte simplificados",
        description:
          'Se eliminó el estado de reporte "Detenido". "Inactivo" ahora se muestra en color naranja para indicar que se requiere una acción del usuario.',
      },
      {
        type: "improved",
        title: "Dispositivos segmentados por estado de instalación",
        description:
          "La tabla de dispositivos de la organización ahora está segmentada por estado de instalación, y los gráficos de torta de la organización ahora muestran solo dispositivos instalados.",
      },
      {
        type: "fixed",
        title: "Actualización de seguridad en el backend",
        description: "Se implementaron correcciones de seguridad en el backend.",
      },
    ],
  },
  {
    release: "2026-06-01",
    changes: [
      {
        type: "improved",
        title: "Estadísticas del último valor en gráficos de flecha y tensión",
        description:
          "Se introdujeron estadísticas de valor único que muestran el último valor de cada línea en los gráficos de tensión del conductor y flecha.",
      },
      {
        type: "improved",
        title: "Diagrama explicativo en el gráfico de tensión del conductor",
        description:
          "Se introdujo un diagrama explicativo para el gráfico de tensión del conductor.",
      },
    ],
  },
  {
    release: "2026-05-18",
    changes: [
      {
        type: "new",
        title: "Indicadores de calidad en puntos de telemetría",
        description:
          "En el modo de datos de alta resolución, los puntos de datos en los gráficos de telemetría ahora reflejan visualmente su nivel de calidad: los puntos con calidad degradada, no confiable o inválida se muestran con un anillo de color que indica la severidad. El tooltip del gráfico también muestra el valor formateado por campo en cada marca de tiempo, en coherencia con la codificación por color de calidad utilizada en el icono de resumen.",
      },
    ],
  },
  {
    release: "2026-05-11",
    changes: [
      {
        type: "new",
        title: "Cruces sincronizados en gráficos",
        description:
          "Se introdujeron cruces sincronizados en todos los gráficos de línea y dispersión. Al pasar el cursor sobre un gráfico, ahora se refleja la posición del cursor en todo el panel, lo que facilita la comparación de datos.",
      },
      {
        type: "new",
        title: 'Campo "Instalado en" en el resumen del dispositivo',
        description:
          'Se añadió un campo "Instalado en" en el encabezado del resumen del dispositivo, mostrando la entidad en la que está instalado el dispositivo junto con su ícono correspondiente y un enlace directo a la página de esa entidad.',
      },
    ],
  },
  {
    release: "2026-05-04",
    changes: [
      {
        type: "new",
        title: "Resumen de calidad de datos en gráficos de telemetría",
        description:
          "Se introdujo la visualización del resumen de calidad de datos en los gráficos de telemetría. Un icono de mini gráfico de torta muestra el desglose porcentual de los niveles de calidad de datos (saludable, degradado, no confiable, inválido) para el período de tiempo seleccionado, lo que permite a los usuarios evaluar la fiabilidad de las mediciones de un vistazo. Al hacer clic en el icono se abre un diálogo detallado con un gráfico de torta completo, porcentajes y descripciones por nivel, y una referencia a los endpoints de la API para obtener metadatos de calidad.",
      },
      {
        type: "new",
        title: "Datos brutos de alta resolución para rangos de tiempo cortos",
        description:
          "Cuando el rango de fechas seleccionado es de 24 horas o menos, los gráficos de telemetría cambian automáticamente al modo de alta resolución, mostrando los puntos de datos exactos sin agregación ni promediado. Un indicador visual en el encabezado del gráfico refleja el modo de datos actual.",
      },
    ],
  },
  {
    release: "2026-04-27",
    changes: [
      {
        type: "new",
        title: "Descarga CSV para las páginas de Línea Eléctrica, Torre y Dispositivo",
        description:
          "Se añadió un botón de descarga CSV en las páginas de Línea Eléctrica, Torre y Dispositivo. Al hacer clic en el botón de descarga junto al selector de fechas, se descargan todas las telemetrías mostradas en ese panel. Si hay telemetrías asociadas a entidades relacionadas, se genera un archivo separado para cada una. Esta funcionalidad está disponible actualmente solo para editores.",
      },
      {
        type: "improved",
        title: "Documentación de la API de telemetría actualizada",
        description:
          "Se mejoró la documentación de la API de telemetría para listar todas las telemetrías visibles en el panel, facilitando la identificación de los campos disponibles para consultar.",
      },
    ],
  },
  {
    release: "2026-04-13",
    changes: [
      {
        type: "improved",
        title: "Ilustraciones para dispositivos v4.0 en torres tipo poste",
        description:
          "Se añadieron nuevas ilustraciones al gráfico de posición para los dispositivos v4.0 instalados en torres tipo poste, mejorando la representación visual de los ángulos alfa y beta en estas configuraciones.",
      },
      {
        type: "new",
        title: "Metadatos de calidad para telemetrías",
        description:
          'Se agregaron metadatos de calidad para telemetrías seleccionadas. En la consulta a /telemetry, agregue include_field_metadata=true para obtener los metadatos asociados (quality_index, quality, reason), o agregue only_quality_summary=true para obtener un resumen de calidad en el período seleccionado. Los metadatos asociados incluyen tres nuevas telemetrías agregadas a cada telemetría: .metadata.quality (ya sea "healthy" [saludable], "degraded" [degradado], "unreliable" [no confiable] o "invalid" [inválido], indicando qué tan buenos son los datos), .metadata.reason (cuando la calidad no es "healthy", lista el motivo) y .metadata.quality_index (un entero que mapea la calidad de mejor a peor, donde 1 es "healthy"). Por ejemplo, consultar field=ampacity.aar&field=ampacity.aar.metadata.quality_index resultará tanto en la ampacidad AAR como en el índice de calidad de esa telemetría.',
      },
    ],
  },
  {
    release: "2026-04-06",
    changes: [
      {
        type: "improved",
        title: "Iconos en la navegación por pestañas",
        description:
          "Se mejoró la navegación por pestañas al añadir iconos a las etiquetas de las pestañas en todas las páginas, y se mejoró la interactividad con un sutil efecto de fondo al pasar el cursor y esquinas redondeadas.",
      },
    ],
  },
  {
    release: "2026-03-30",
    changes: [
      {
        type: "new",
        title: "Ilustraciones para dispositivos de torre",
        description:
          "Se introdujeron ilustraciones para los nuevos dispositivos de torre, mostrando los ángulos de posición en relación con la sección de instalación.",
      },
    ],
  },
  {
    release: "2026-03-23",
    changes: [
      {
        type: "new",
        title: "Pestaña de Ambiente para dispositivos de torre",
        description:
          "Se añadió una pestaña de Ambiente condicional para dispositivos instalados en una torre que tienen una estación meteorológica asociada. Esta pestaña muestra la información reportada por la estación meteorológica.",
      },
    ],
  },
  {
    release: "2026-03-16",
    changes: [
      {
        type: "new",
        title: "Pestañas de Torre y Dispositivo",
        description:
          "Se dividió la pestaña de Información del dispositivo de torre en pestañas separadas de Torre y Dispositivo para una organización más clara de la información del dispositivo.",
      },
      {
        type: "new",
        title: "Línea de referencia de ampacidad nominal",
        description:
          "Se añadió una línea de referencia de ampacidad nominal al gráfico de ampacidad de la página de línea eléctrica para facilitar la comparación de los valores de ampacidad con el umbral nominal.",
      },
      {
        type: "improved",
        title: "Rango de fechas de la ventana de activación",
        description:
          "Se renombró la referencia de fecha 'último disparador' a 'ventana de disparador' para mayor claridad. El período de la ventana de disparador ahora comienza un día antes del momento en que se disparó la alerta, en lugar de una semana, proporcionando una vista más enfocada del contexto del evento.",
      },
      {
        type: "fixed",
        title: "Límites del rango de fechas del gráfico",
        description:
          "Se corrigieron los gráficos de línea y dispersión para mostrar siempre el rango de fechas completo seleccionado en el eje x. Anteriormente, el eje comenzaba en el primer punto de datos disponible en lugar de la fecha de inicio solicitada, lo que hacía que el rango visible pareciera más corto de lo esperado.",
      },
    ],
  },
  {
    release: "2026-02-23",
    changes: [
      {
        type: "new",
        title: "Visualización de vano crítico",
        description:
          "Se introdujo la visualización de los últimos vanos críticos, tanto para ampacidad AAR como para ampacidad DLR en el mapa de línea eléctrica en la página de línea eléctrica.",
      },
    ],
  },
  {
    release: "2026-02-18",
    changes: [
      {
        type: "new",
        title: "Endpoint de telemetría de vano",
        description:
          "Se introdujo un nuevo endpoint para consultar datos relacionados con vanos: '/powerlines_spans/int:span_id/telemetry'.",
      },
      {
        type: "new",
        title: "Gráficos de ampacidad de tramo en la página de dispositivo",
        description:
          "Se introdujeron los gráficos 'Ampacidad del vano (AAR)' y 'Última ampacidad del vano (AAR)' en la pestaña de Vano de la página de dispositivo, mostrando datos AAR para el vano en el que está instalado el dispositivo.",
      },
      {
        type: "improved",
        title: "Mejora del control de capas del mapa",
        description:
          "Se mejoraron los colores del control de capas del mapa para una mejor consistencia visual. Además, el control de capas ahora aparece expandido por defecto en mapas grandes para facilitar el acceso a las opciones de visibilidad de las capas.",
      },
      {
        type: "improved",
        title: "Descripciones del gráfico de ampacidad",
        description:
          "Se actualizaron las descripciones de AAR y DLR en el gráfico de ampacidad de línea eléctrica para mayor claridad.",
      },
    ],
  },
  {
    release: "2026-02-09",
    changes: [
      {
        type: "new",
        title: "Estadísticas únicas de estación meteorológica",
        description:
          "Se introdujeron datos destacados que muestran el último valor de cada gráfico en dispositivos de estación meteorológica para garantizar la coherencia y mejorar la usabilidad.",
      },
      {
        type: "new",
        title: "Estadísticas únicas de servicio meteorológico",
        description:
          "Se introdujeron datos destacados que muestran el último valor de cada gráfico de telemetría del servicio meteorológico en la página de Torre para garantizar la coherencia y mejorar la usabilidad.",
      },
      {
        type: "new",
        title: "Período de pronóstico extendido",
        description:
          "Se extendió el selector de rango de fechas personalizado en la página de línea eléctrica para permitir la selección hasta 14 días en el futuro, habilitando la visualización de un período de pronóstico más largo.",
      },
      {
        type: "new",
        title: "Campos de pronóstico de ampacidad AAR y DLR separados",
        description:
          "Los campos de pronóstico de ampacidad ahora muestran valores separados para AAR (Clasificación Ajustada al Ambiente) y DLR (Clasificación Dinámica de Línea) para proporcionar información más detallada.",
      },
      {
        type: "new",
        title: "Mejora de visualización de pronóstico de ampacidad",
        description:
          "Se agregó un área sombreada entre las líneas de pronóstico AAR y DLR en el gráfico de ampacidad para visualizar mejor el rango de operación.",
      },
      {
        type: "improved",
        title: "Cálculos conservadores de AAR",
        description:
          "AAR ahora se calcula usando como máximo 0.6 m/s o un valor más bajo proporcionado por el servicio meteorológico. Esto resulta en una ampacidad más conservadora siguiendo las prácticas de la industria y las sugerencias de IEEE y CIGRE.",
      },
    ],
  },
  {
    release: "2026-02-02",
    changes: [
      {
        type: "new",
        title: "Gráfico de inclinación de dispositivos en la página de torre",
        description:
          "Se introdujo un gráfico que muestra los datos promedio de inclinación de todos los dispositivos en una torre para mejorar la experiencia del usuario.",
      },
    ],
  },
  {
    release: "2026-01-26",
    changes: [
      {
        type: "new",
        title: "Superposición de interacción del mapa",
        description:
          "Se agregó una superposición de interacción a los mapas para evitar el zoom accidental al desplazarse por el panel. Los usuarios ahora pueden hacer clic en el mapa para habilitar la interacción completa, asegurando una experiencia de navegación más fluida en toda la página.",
      },
      {
        type: "new",
        title: "Referencia del gráfico de dirección del viento",
        description:
          "Se agregó una explicación sobre cómo interpretar los valores de dirección del viento de las estaciones meteorológicas en el tooltip del gráfico para una mejor comprensión.",
      },
      {
        type: "new",
        title: "Funcionalidad de zoom en gráficos",
        description:
          "Se introdujo la funcionalidad de zoom para gráficos que permite a los usuarios seleccionar períodos de tiempo específicos arrastrando en el gráfico. Mientras está en modo zoom, el período seleccionado se conserva al navegar entre pestañas dentro de la misma página y se muestra en el selector de fecha con un indicador '(con zoom)'. Los usuarios pueden salir del modo zoom a través de un botón dedicado o seleccionando un nuevo rango de fechas, volviendo automáticamente a las actualizaciones de datos en vivo. El modo zoom finaliza automáticamente al salir de la página. Nota: Los rangos de fechas personalizados se reemplazan directamente con un nuevo rango personalizado en lugar de entrar en modo zoom.",
      },
      {
        type: "improved",
        title: "Indicador de carga del selector de fecha",
        description:
          "Se mejoró la precisión del spinner de carga del selector de fecha. El spinner ahora aparece solo cuando un gráfico de la página actual se está cargando, proporcionando una retroalimentación más clara sobre el estado de carga de datos.",
      },
    ],
  },
  {
    release: "2026-01-19",
    changes: [
      {
        type: "new",
        title: "Pestañas del panel de estación meteorológica",
        description:
          "El panel de dispositivos tipo estación meteorológica ahora está dividido en dos pestañas separadas de ambiente y dispositivo para una mejor organización y claridad.",
      },
    ],
  },
  {
    release: "2026-01-12",
    changes: [
      {
        type: "new",
        title: "Gráfico de ráfagas de viento",
        description:
          "Se introdujo un nuevo gráfico del servicio meteorológico que muestra las ráfagas de viento en la página de torre.",
      },
      {
        type: "improved",
        title: "Actualización automática de la página de torre",
        description:
          "Se actualizó la página de torre para que se refresque cada 5 minutos, consistente con las otras páginas de entidades.",
      },
    ],
  },
  {
    release: "2025-12-18",
    changes: [
      {
        type: "new",
        title: "Gráfico de detección de acumulación de hielo",
        description:
          "Se introdujo un nuevo gráfico que muestra la acumulación potencial de hielo. El eje y muestra los tipos de hielo (Hielo vítreo, Hielo vítreo y escarcha dura, Escarcha dura, Nieve húmeda y hielo vítreo, Nieve húmeda y Sin hielo). Las barras horizontales indican la duración de cada tipo de hielo detectado, y los colores y el tooltip informan su nivel de severidad (0 a 5).",
      },
      {
        type: "new",
        title: "Estadística única de acumulación de hielo",
        description:
          "Se agregó un dato destacado que muestra el último tipo de acumulación de hielo detectado del período de tiempo seleccionado.",
      },
      {
        type: "improved",
        title: "Visualización de temperatura límite del span",
        description:
          "Se agregó la temperatura límite del span al tooltip del mapa de span, cuando está presente. Los spans ahora son visibles por defecto en el panel de línea eléctrica para una mejor visibilidad.",
      },
    ],
  },
  {
    release: "2025-12-09",
    changes: [
      {
        type: "improved",
        title: "Mejoras en el gráfico de intensidad de movimiento",
        description:
          "Se mejoró el gráfico de intensidad de movimiento con ajustes menores de terminología y se agregó la unidad apropiada.",
      },
      {
        type: "new",
        title: "Estadística única de fatiga acumulada",
        description:
          "Se agregó un dato destacado que muestra el último valor de fatiga acumulada para el período de tiempo seleccionado en la pestaña de span en la página del dispositivo.",
      },
      {
        type: "improved",
        title: "Efectos de hover en la interacción del mapa",
        description:
          "Se introdujeron efectos de hover para elementos del mapa, incluyendo el ensanchamiento de líneas para líneas eléctricas y spans, junto con la reducción de opacidad en los elementos no seleccionados para facilitar la distinción de los puntos de inicio y fin, y se agregó un efecto de escala para dispositivos y torres.",
      },
    ],
  },
  {
    release: "2025-12-01",
    changes: [
      {
        type: "new",
        title: "Gráfico de fatiga acumulada",
        description:
          "Se reemplazó el gráfico de fatiga diaria con el gráfico de fatiga acumulada para proporcionar datos más precisos y útiles.",
      },
      {
        type: "new",
        title: "Sombreado de sección de pronóstico",
        description:
          "Se agregó un fondo sombreado para los gráficos que incluyen pronósticos para mejorar la distinción visual entre datos reales y pronosticados.",
      },
      {
        type: "improved",
        title: "Visualización de detalles de instalación",
        description:
          "Se mejoraron los detalles de instalación para mostrar los nombres de las entidades junto a sus ID correspondientes, haciendo la información más clara y fácil de identificar.",
      },
      {
        type: "improved",
        title: "Especificidad de notas de agrupación",
        description:
          "Se refinaron las notas de ayuda para cada gráfico en relación con la agrupación de datos utilizados, proporcionando información más específica para cada función de agrupación.",
      },
      {
        type: "improved",
        title: "Descripción de autoresolución de alerta de movimiento",
        description:
          "Se agregó una explicación detallada de la funcionalidad de autoresolución de alerta de movimiento en el formulario de creación de configuración de alertas.",
      },
      {
        type: "improved",
        title: "Mensaje de error de token expirado",
        description:
          "Se mejoró el manejo de errores para tokens de autenticación expirados, ahora devuelve un mensaje claro 'Token has expired'.",
      },
    ],
  },
  {
    release: "2025-11-25",
    changes: [
      {
        type: "new",
        title: "Visualización de marca de tiempo de ampacidad a corto plazo",
        description:
          "Se agregó la visualización de marca de tiempo para datos de ampacidad a corto plazo para mostrar cuándo se tomaron las mediciones.",
      },
      {
        type: "new",
        title: "Marca de tiempo original en gráficos de telemetría",
        description:
          "Se mejoraron los gráficos para usar la marca de tiempo real de los datos medidos siempre que sea posible, mejorando la precisión.",
      },
      {
        type: "fixed",
        title: "Exportación CSV con caracteres especiales",
        description:
          "Se corrigieron las descargas de CSV para manejar correctamente los caracteres especiales en las exportaciones de datos de tablas y gráficos.",
      },
      {
        type: "fixed",
        title: "Actualizaciones de estado de alertas",
        description:
          "Las acciones de alertas ahora solo funcionan en alertas previamente disparadas, evitando cambios de estado no deseados.",
      },
    ],
  },
  {
    release: "2025-11-17",
    changes: [
      {
        type: "new",
        title: "Telemetría de fatiga acumulativa",
        description:
          "Se agregó telemetría de fatiga acumulativa interpolada para días sin valores de fatiga diaria, mejorando la continuidad en el seguimiento de fatiga.",
      },
      {
        type: "fixed",
        title: "Consulta de datos de ampacidad a corto plazo",
        description:
          "Se corrigió el parámetro de consulta para la recuperación de datos de ampacidad a corto plazo para garantizar la agregación adecuada de datos.",
      },
    ],
  },
  {
    release: "2025-11-10",
    changes: [
      {
        type: "new",
        title: "Funcionalidad de registro de cambios",
        description:
          "Se introdujo una nueva funcionalidad de registro de cambios con un popover que muestra los cambios de la última versión, una página dedicada que muestra el historial completo y un distintivo 'Nuevo' que aparece durante dos días después de cada lanzamiento.",
      },
      {
        type: "new",
        title: "Visualización de datos meteorológicos",
        description:
          "Se agregaron gráficos del servicio meteorológico a la página de torre, incluyendo velocidad del viento, dirección del viento, temperatura, humedad relativa y gráficos de precipitación para un mejor monitoreo ambiental.",
      },
      {
        type: "new",
        title: "Visualización de ampacidad a corto plazo",
        description:
          "Se agregó soporte para visualizar datos de ampacidad a corto plazo para ayudar a operar líneas eléctricas en condiciones extremas.",
      },
      {
        type: "improved",
        title: "Selección de idioma movida al menú de perfil",
        description:
          "Se reubicó el selector de idioma al menú de perfil para una interfaz más limpia y una mejor experiencia de usuario.",
      },
      {
        type: "fixed",
        title: "Visualización del tooltip de flecha",
        description:
          "Se eliminaron los valores de coordenadas X e Y del tooltip de flecha para una presentación de datos más precisa.",
      },
    ],
  },
  {
    release: "2025-11-03",
    changes: [
      {
        type: "new",
        title: "Cálculos de ampacidad a corto plazo",
        description:
          "Se agregó soporte para telemetrías de ampacidad a corto plazo y de emergencia, permitiendo una mejor predicción de la capacidad de las líneas eléctricas bajo condiciones variables.",
      },
      {
        type: "new",
        title: "Endpoint API de servicio meteorológico",
        description:
          "Se introdujo un nuevo endpoint /weather_service que permite a los usuarios acceder a datos meteorológicos de terceros para un mejor monitoreo ambiental.",
      },
    ],
  },
  {
    release: "2025-10-27",
    changes: [
      {
        type: "new",
        title: "Detalles de línea eléctrica",
        description:
          "Se agregaron detalles a la página de línea eléctrica incluyendo ID, tensión nominal, ampacidad nominal y longitud para una mejor visualización.",
      },
      {
        type: "new",
        title: "Estado de reporte desconocido",
        description: "Se agregó un nuevo estado de reporte para mejorar el monitoreo.",
      },
    ],
  },
  {
    release: "2025-10-20",
    changes: [
      {
        type: "new",
        title: "Detalles de torre",
        description:
          "Se agregaron detalles a la página de torre incluyendo ID, tipo y altura para una mejor visualización.",
      },
      {
        type: "fixed",
        title: "Ilustraciones de dispositivos",
        description:
          "Se corrigió la ubicación del botón y la superposición de elementos en las ilustraciones de dispositivos instalados en torres para mayor claridad.",
      },
    ],
  },
]
